import React from 'react';
import { Container } from './style';

export const HoverableFadingContainer = ({ children }) => <Container>{children}</Container>;



// WEBPACK FOOTER //
// ./src/UI/Components/HoverableFadingContainer/index.js